import { render } from "./CustomerDetailsCardEmpty.vue?vue&type=template&id=7818135e&scoped=true&ts=true&lang=pug"
import script from "./CustomerDetailsCardEmpty.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerDetailsCardEmpty.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerDetailsCardEmpty.vue?vue&type=style&index=0&id=7818135e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7818135e"]])

export default __exports__